import type { UserStep } from '../models/UserStep';

/**
 * The user-step fields a progress save sends: the defined ones of progress /
 * score / completion_date / time_accumulator, plus start_date — the existing
 * one, else now (or null when this save must not stamp a start, BUG-33).
 */
export function buildStepSaveData(
  userStepData: Partial<UserStep>,
  existingStartDate: string | null | undefined,
  stampStart = true,
) {
  const { progress, score, completion_date, time_accumulator } = userStepData;
  const stepData = {};
  if (progress !== undefined) Object.assign(stepData, { progress });
  if (score !== undefined) Object.assign(stepData, { score });
  if (completion_date !== undefined)
    Object.assign(stepData, { completion_date });
  if (time_accumulator !== undefined)
    Object.assign(stepData, { time_accumulator });
  Object.assign(stepData, {
    start_date:
      existingStartDate ?? (stampStart ? new Date().toISOString() : null),
  });
  return stepData;
}
